import { Component, inject, OnInit } from '@angular/core';
import { ToolbarService } from '../../services/toolbar.service';
import { NgClass } from '@angular/common';
import { EstimagePayApplicationComponent } from './estimage-pay-application/estimage-pay-application.component';
import { EstimagePayInvoiceTableComponent } from './estimage-pay-invoices/estimage-pay-invoice-table.component';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-estimage-pay-page',
  imports: [EstimagePayApplicationComponent, EstimagePayInvoiceTableComponent, NgClass],
  template: `
    <div
      class="m-20"
      [ngClass]="{
        'mt-[75px]!': !userService.showRepairerWarningBanner(),
        'mt-[130px]!': userService.showRepairerWarningBanner()
      }">
      <div class="flex flex-col gap-40">
        <estimage-pay-application />
        <estimage-pay-invoice-table />
      </div>
    </div>
  `
})
export class EstimagePayPageComponent implements OnInit {
  #toolbarService = inject(ToolbarService);
  userService = inject(UserService);

  ngOnInit(): void {
    this.#toolbarService.toolbarData({ pageName: 'EstImage Pay', backLink: 'dashboard' });
  }

  refresh(): void {}
}
